<template>
    <div id="order-plugin" class="order-plugin">
        <div v-if="!loading && !error">

            <!-- route outlet -->
            <!-- component matched by the route will render here -->
            <router-view/>

        </div>

        <div v-if="error">
            Zur Zeit kann diese Seite nicht vollständig geladen werden. Bitte versuche es später noch einmal.
        </div>

    </div>
</template>

<script>
export default {
    props: {
        mode: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            error: false,
        };
    },
    created() {
        this.$store.dispatch('updateMode', this.mode);
    },
};
</script>



// WEBPACK FOOTER //
// App.vue?45b41834